import React, { Fragment } from 'react';

const ProductBuyButton = ({
                              label,
                              items,
                              cssClass,
                              onClick,
                              children
                          }) => {
    return (
        <Fragment>
            {children}
            <button
                className={cssClass}
                onClick={(e) => {
                    e.preventDefault();

                    if (items.length === 0) {
                        return
                    }

                    onClick(items);
                }}
            >
                {label}
            </button>
        </Fragment>
    );
};

export default ProductBuyButton;
